"use strict";
/*
 * Copyright (c) 2018 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatasourceActivityStatus = void 0;
var DatasourceActivityStatus;
(function (DatasourceActivityStatus) {
    DatasourceActivityStatus["START"] = "START";
    DatasourceActivityStatus["FETCHING"] = "FETCHING";
    DatasourceActivityStatus["DONE"] = "DONE";
    DatasourceActivityStatus["FAILED"] = "FAILED";
})(DatasourceActivityStatus = exports.DatasourceActivityStatus || (exports.DatasourceActivityStatus = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGF0YXNvdXJjZS1hY3Rpdml0eS1zdGF0dXMtZW51bS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9zeXN0ZW0tYWN0aXZpdHkvZGF0YXNvdXJjZS1hY3Rpdml0eS1zdGF0dXMtZW51bS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUE7Ozs7OztHQU1HOzs7QUFFSCxJQUFZLHdCQUtYO0FBTEQsV0FBWSx3QkFBd0I7SUFDbEMsMkNBQWUsQ0FBQTtJQUNmLGlEQUFxQixDQUFBO0lBQ3JCLHlDQUFhLENBQUE7SUFDYiw2Q0FBaUIsQ0FBQTtBQUNuQixDQUFDLEVBTFcsd0JBQXdCLEdBQXhCLGdDQUF3QixLQUF4QixnQ0FBd0IsUUFLbkMifQ==